export const addTableStyles = (theme) => ({
  root: {
    width: '100%',
  },
  table: {
    minWidth: 750,
  },
})
